import ApiService from '@/services/core/api.service'

const BudgetApproverService = {
  async get (query = '') {
    return ApiService.get(`budget-officer/budget-approvers?${query}`)
  },

  async post (payload) {
    return ApiService.post('budget-officer/budget-approvers', payload)
  },

  async put (payload) {
    return ApiService.put(`budget-officer/budget-approvers/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`budget-officer/budget-approvers/${payload.id}`)
  }
}

export default BudgetApproverService
